import React, { useEffect } from "react";
import { useNavigate } from "react-router";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import AuthLayout from "layouts/AuthLayout";

import ResetPasswordForm from "./ResetPasswordForm";

import { useAppDispatch } from "store/hooks";
import { setNotification } from "store/features/notificationSlice";

import { routes } from "routes/routes";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const params = new URLSearchParams(window.location.search);
  const userEmail = params.get("email");
  const token = params.get("token");

  useEffect(() => {
    if (!userEmail || !token) {
      navigate(routes.auth);

      dispatch(
        setNotification({
          severity: "error",
          message: "Помилка спроби відновлення пароля. Спробуйте ще раз.",
        })
      );
    }
  }, [userEmail, token]);

  return (
    <AuthLayout>
      <Paper sx={{ width: { xs: "100%", sm: "480px" }, m: 2 }}>
        <Box>
          <Typography sx={{ mb: 1 }} variant="body1" color="grey700">
            {userEmail}
          </Typography>
          <Typography sx={{ mb: 3 }} variant="h5">
            Відновлення пароля
          </Typography>

          <ResetPasswordForm email={userEmail} token={token} />
        </Box>
      </Paper>
    </AuthLayout>
  );
};

export default ResetPassword;
